import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import ResetPassword from '../pages/ResetPassword';

const ResetPasswordGuard = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // Check if token exists and has basic format validation
  if (!token) {
    return <Navigate 
      to="/login" 
      state={{ 
        error: 'Invalid password reset link. Please request a new password reset from the login page.' 
      }} 
      replace 
    />;
  }

  // Basic token format validation (should be 64 character hex string)
  const tokenPattern = /^[a-f0-9]{64}$/i;
  if (!tokenPattern.test(token)) {
    return <Navigate 
      to="/login" 
      state={{ 
        error: 'Invalid password reset token format. Please request a new password reset.' 
      }} 
      replace 
    />;
  }

  // Token exists and has valid format - allow access to reset password page
  return <ResetPassword />;
};

export default ResetPasswordGuard; 